export default __webpack_public_path__ + "static/media/Group 85.49ef0148.png";